import { useState } from "react";
import { Menu, X, Sparkles, Phone } from "lucide-react";
import { LOGO_URL } from "@/constants/assets";

const links = [
  { label: "Services", href: "#services", testid: "nav-link-services" },
  { label: "Before & After", href: "#before-after", testid: "nav-link-before-after" },
  { label: "Founder", href: "#founder", testid: "nav-link-founder" },
  { label: "Reviews", href: "#reviews", testid: "nav-link-reviews" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-md bg-[#FAF7F2]/85 border-b border-[#E5DEC9]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 md:h-20 flex items-center justify-between">
        <a href="#top" data-testid="navbar-brand-logo" className="flex items-center gap-3 group">
          <img src={LOGO_URL} alt="Tidy Tusks logo" className="h-10 w-10 md:h-12 md:w-12 object-contain transition-transform duration-300 group-hover:-rotate-6" />
          <div className="leading-none">
            <span className="font-display font-bold text-lg md:text-xl tracking-tight">Tidy <span className="text-[#990000]">Tusks</span></span>
            <span className="hidden md:block text-[10px] font-semibold uppercase tracking-[0.2em] text-[#5C5955] mt-0.5">Professional Cleaning</span>
          </div>
        </a>
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a key={l.href} href={l.href} data-testid={l.testid} className="text-sm font-semibold text-[#2D2D2D] hover:text-[#990000] transition-colors duration-200">
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-2.5">
          <a href="tel:9185750005" data-testid="nav-call-btn" className="inline-flex items-center gap-2 border-2 border-[#1A1A1A] text-[#1A1A1A] text-sm font-semibold py-2 px-4 rounded-full hover:bg-[#1A1A1A] hover:text-white transition-all duration-200">
            <Phone size={15} /> <span className="hidden sm:inline">918-575-0005</span>
          </a>
          <a href="#quote" data-testid="nav-book-clean-btn" className="hidden sm:inline-flex items-center gap-2 bg-[#990000] text-white text-sm font-semibold py-2.5 px-5 rounded-full shadow-md hover:bg-[#7A0000] hover:shadow-lg hover:-translate-y-0.5 transition-all duration-200">
            <Sparkles size={15} /> Book Clean
          </a>
          <button data-testid="nav-mobile-menu-btn" onClick={() => setOpen(!open)} className="md:hidden p-2 rounded-lg border border-[#E5DEC9]" aria-label="Toggle menu">
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>
      {open && (
        <div className="md:hidden border-t border-[#E5DEC9] bg-[#FAF7F2] px-5 py-4 flex flex-col gap-3">
          {links.map((l) => (
            <a key={l.href} href={l.href} data-testid={`${l.testid}-mobile`} onClick={() => setOpen(false)} className="text-sm font-semibold py-1.5">
              {l.label}
            </a>
          ))}
          <a href="tel:9185750005" data-testid="nav-call-btn-mobile" onClick={() => setOpen(false)} className="text-sm font-semibold py-1.5 flex items-center gap-2">
            <Phone size={15} /> Call 918-575-0005
          </a>
          <a href="#quote" data-testid="nav-book-clean-btn-mobile" onClick={() => setOpen(false)} className="mt-1 inline-flex justify-center bg-[#990000] text-white text-sm font-semibold py-2.5 px-5 rounded-full">
            Book Clean
          </a>
        </div>
      )}
    </header>
  );
};

export default Navbar;
